export var TypeActionThemedEvent;
(function (TypeActionThemedEvent) {
    TypeActionThemedEvent["BuildingClicked"] = "ThemedEvent > BuildingClicked";
    TypeActionThemedEvent["StartRequest"] = "ThemedEvent > StartRequest";
    TypeActionThemedEvent["StartResponse"] = "ThemedEvent > StartResponse";
    TypeActionThemedEvent["FinishRequest"] = "ThemedEvent > FinishRequest";
    TypeActionThemedEvent["FinishResponse"] = "ThemedEvent > FinishResponse";
    TypeActionThemedEvent["CollectReward"] = "ThemedEvent > CollectReward";
    TypeActionThemedEvent["RewardCollected"] = "ThemedEvent > RewardCollected";
    TypeActionThemedEvent["LoadBuilding"] = "ThemedEvent > LoadBuilding";
})(TypeActionThemedEvent || (TypeActionThemedEvent = {}));
export var actionThemedEventStartRequest = function (eventId, difficulty) { return ({
    difficulty: difficulty,
    eventId: eventId,
    type: TypeActionThemedEvent.StartRequest,
}); };
export var actionThemedEventStartResponse = function (eventId, quest, difficulty) { return ({
    difficulty: difficulty,
    eventId: eventId,
    quest: quest,
    type: TypeActionThemedEvent.StartResponse,
}); };
export var actionThemedEventFinishRequest = function (eventId) { return ({
    eventId: eventId,
    type: TypeActionThemedEvent.FinishRequest,
}); };
export var actionThemedEventFinishResponse = function (eventId) { return ({
    eventId: eventId,
    type: TypeActionThemedEvent.FinishResponse,
}); };
export var actionThemedEventBuildingClicked = function () { return ({
    type: TypeActionThemedEvent.BuildingClicked,
}); };
export var actionThemedEventCollectReward = function (rewardId, rewardAmount) { return ({
    rewardAmount: rewardAmount,
    rewardId: rewardId,
    type: TypeActionThemedEvent.CollectReward,
}); };
export var actionThemedEventRewardCollected = function () { return ({
    type: TypeActionThemedEvent.RewardCollected,
}); };
export var actionThemedEventLoadBuilding = function () { return ({
    type: TypeActionThemedEvent.LoadBuilding,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/actionThemedEvent.ts
// module id = 136
// module chunks = 3